<template>
  <div class="page">
    <div class="app-container">
      <BaseSearch
        v-model="searchData"
        :formOptions="searchFormOption"
        @handleSearch="handleSearch"
      >
      </BaseSearch>
      <el-button type="primary" @click="add">新增延期</el-button>

      <BaseTable
        ref="baseTable"
        url="admin/DelayBill/index"
        :tableData.sync="tableData"
        :searchParams="searchData"
        :columns="columns"
        :paramsCepCallback="paramsCepCallback"
      >
        <template #custom="{ scope }">
          {{ scope.row.title }}
        </template>
        <template #handle="{ row }">
          <el-button type="text" size="mini" @click="detail(row)"
            >详情</el-button
          >
          <el-button type="text" size="mini" @click="edit(row)">编辑</el-button>
          <el-button type="text" size="mini" @click="del(row)"
            >取消延期</el-button
          >
        </template>
      </BaseTable>

      <!-- 延期新增/详情 -->
      <el-drawer title="延期" :visible.sync="isShowDrawer" direction="rtl">
        <div style="padding: 40px">
          <div style="flex"></div>
          <el-form labelWidth="100px" size="medium">
            <el-form-item label="查询：" v-show="!isEdit">
              <el-input
                placeholder="请输入统筹单流水号/车牌号"
                v-model="formData.insBillId"
              >
                <template slot="append"
                  ><i class="el-icon-search" @click="handleSearchDetail"></i
                ></template>
              </el-input>
            </el-form-item>

            <el-form-item label="统筹单号：" label-width="120px">
              {{ billData.bh }}
            </el-form-item>
            <el-form-item label="流水号：" label-width="120px">
              {{ billData.insBillId }}
            </el-form-item>
            <el-form-item label="统筹起期：" label-width="120px">
              {{ billData.beginTime }}
            </el-form-item>
            <el-form-item label="统筹止期：" label-width="120px">
              {{ billData.endTime }}
            </el-form-item>
            <el-form-item label="业务员：" label-width="120px">
              {{ billData.realname }}
            </el-form-item>
            <el-form-item label="出单机构：" label-width="120px">
              {{ billData.orgName }}
            </el-form-item>
            <div class="line"></div>
            <el-form-item label="服务止期延迟：" label-width="120px">
              <el-date-picker
                v-model="formData.delayTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                :disabled="disabled"
                align="right"
                type="datetime"
                placeholder="选择日期"
                required
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="暂停日期：" label-width="120px">
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="pauseTime"
                range-separator="至"
                :disabled="disabled"
                align="right"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="handleChangeRangeDateTime"
                required
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="特别约定：" label-width="120px">
              <el-button
                v-show="!disabled"
                style="margin-bottom: 20px"
                type="primary"
                size="small"
                @click="isShowSpecialDialog = true"
                >选择特约</el-button
              >
              <el-input
                type="textarea"
                :disabled="disabled"
                v-model="formData.specialRemark"
                required
              ></el-input>
            </el-form-item>
            <el-form-item label="附件：" label-width="120px">
              <el-upload
                class="avatar-uploader"
                action=""
                list-type="picture-card"
                :auto-upload="false"
                :file-list="fileList"
                name="img"
                :on-change="(file) => handleChangeFile(file)"
                :on-preview="handlePictureCardPreview"
                :on-remove="(file, fileList) => handleRemoveImg(file)"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="preVisible">
                <img width="100%" :src="preImageUrl" alt="" />
              </el-dialog>
            </el-form-item>

            <el-button style="margin-top: 50px" type="primary" @click="onSubmit"
              >保存</el-button
            >
          </el-form>
        </div>
      </el-drawer>

      <!-- 选择特约 -->
      <el-dialog
        title="选择特约"
        :visible.sync="isShowSpecialDialog"
        direction="rtl"
      >
        <BaseTable
          ref="baseTable"
          url="/admin/special/index"
          :tableData.sync="agreementList"
          :columns="agreementColumns"
        >
          <template #handle="{ row }">
            <el-button type="text" size="mini" @click="selectAgreement(row)">
              选择</el-button
            >
          </template>
        </BaseTable>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { searchFormOption } from "./formOptions";
import { columns, agreementColumns } from "./columns";
import { rules } from "./rules";
export default {
  name: "Delay",
  comments: {},
  data() {
    return {
      tableData: [],
      // 特约列表
      agreementList: [],
      // 查询数据
      searchData: {},
      // 统筹单数据
      billData: {},
      // 文件列表
      fileList: [],
      // 表单数据
      formData: {
        insBillId: "",
        delayTime: "",
        startTime: "",
        endTime: "",
        specialRemark: "",
        enc: "",
      },
      // 暂停日期
      pauseTime: [],
      // 是否显示选择特约弹窗
      isShowSpecialDialog: false,
      preImageUrl: "",
      preVisible: false,
      orgOption: [],
      // 是否显示新增/详情弹框
      isShowDrawer: false,
      // 是否为编辑
      isEdit: true,
      // 新增编辑页面是否禁用
      disabled: false,
	  //暂停天数
	  day: 0,
    };
  },
  computed: {
    columns,
    agreementColumns,
    searchFormOption,
    rules,
  },
  created() {
    this.getOrg();
  },
  methods: {
    getOrg() {
      this.$api.post("/admin/org/index", {}).then((res) => {
        this.orgOption = res?.data?.data;
      });
    },
    // 打开新增延期弹窗
    add() {
      this.formData = {
        insBillId: "",
        delayTime: "",
        startTime: "",
        endTime: "",
        specialRemark: "",
        enc: "",
      };
      this.billData = {};
      this.disabled = true;
      this.isShowDrawer = true;
      this.isEdit = false;
    },
    // 打开延期详情
    detail(row) {
      this.$router.push({
        path: "/issue/detail",
        query: {
          insBillId: row.insBillId,
        },
      });
    },

    // 打开延期详情
    edit(row) {
      this.formData = {
        insBillId: row.insBillId,
        delayTime: row.delayTime,
        startTime: row.startTime,
        endTime: row.endTime,
        specialRemark: row.specialRemark,
        enc: row.enc,
      };
      this.handleSearchDetail();
      this.pauseTime = [row.startTime, row.endTime];
      this.fileList = [];
      row.enc.forEach((item) => {
        this.fileList.push({
          url: item,
        });
      });
      this.isShowDrawer = true;
      this.isEdit = true;
    },

    selectAgreement(row) {
      this.formData.specialRemark = row.tyName + "：" + row.tyContent;
      this.isShowSpecialDialog = false;
    },

    del(row) {
      this.$confirm("确定取消延期吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$api
          .post("/admin/DelayBill/delDelay", {
            insBillId: row.insBillId,
          })
          .then(() => {
            this.$message.success("取消成功");
            this.handleSearch();
          });
      });
    },

    // 新增延期
    onSubmit() {
      if (!this.billData.beginTime) {
        this.$message({
          message: "请选择统筹单",
          type: "error",
        });
        return;
      }

      const urlList = this.fileList.map((item) => item.url);
      this.formData.enc = urlList.join(",");

      let keys = Object.keys(this.rules);
      for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        if (!this.formData[key]) {
          this.$message({
            message: this.rules[key].message,
            type: "error",
          });
          return;
        }
      }

      this.$api
        .post("admin/DelayBill/saveDelay", this.formData, "延期")
        .then(() => {
          this.isShowDrawer = false;
		  this.handleSearch();
        });
    },

    // 查询统筹单详情
    handleSearchDetail() {
      this.$api
        .post("admin/returnbill/getBillDetail", {
          insBillId: this.formData.insBillId,
        })
        .then((res) => {
          this.disabled = false;
          this.billData = res.data;
		  this.formData.delayTime = res.data.endTime;
        });
    },

    handleSearch() {
      this.$refs.baseTable.searchData(1);
    },

    // 监听时间区间选择器
    handleChangeRangeDateTime(val) {
	  const startTime = val[0];
	  let endTime = val[1].split(' ');
	  if(endTime[1] == '00:00:00'){
		  endTime[1] = '23:59:59';
	  }
	  endTime = endTime.join(' ');
      this.formData.startTime = startTime;
      this.formData.endTime = endTime;
	  this.pauseTime = [startTime,endTime];
	  
	  const day = this.getDifferTime(startTime, endTime);
	  
	  if(this.day != day){
		  this.$confirm("服务单已设置暂停"+day+"天，是否自动设置延迟后的统筹止期?", "提示", {
			confirmButtonText: "确定",
			cancelButtonText: "取消",
			type: "warning",
		  }).then(() => {
			//更新服务止期
			this.formData.delayTime = this.addDate(this.billData.endTime,day);
		  });
		  this.day = day;
	  }
    },

    // 上传图片监听
    async handleChangeFile(file) {
      this.loading = true;
      const fd = new FormData();

      fd.append("img", file.raw);
      fd.append("path", "20");
      const res = await this.$api.upload("/admin/upload/upimg", fd);
      if (res.code === 10000) {
        this.fileList.push({
          url: res.data.path,
        });
      } else {
        this.$message.error(res.msg);
      }
      this.loading = false;
    },

    // 删除图片
    handleRemoveImg(res) {
      this.fileList = this.fileList.filter((el) => el.url !== res.url);
    },

    // 预览图片
    handlePictureCardPreview(file) {
      this.preImageUrl = file.url;
      this.preVisible = true;
    },

    // 上传图片成功后
    uploadImgSuccess(res) {
      this.formData.enc = res.data.path;
    },

    // 搜索参数拦截
    paramsCepCallback(params) {
      return {
        ...params,
        ...this.searchData,
      };
    },
	//计算两个时间差
	getDifferTime(startDate, endDate) {
	   let startTime = new Date(Date.parse(startDate.replace(/-/g, "/"))).getTime();
	   let endTime = new Date(Date.parse(endDate.replace(/-/g, "/"))).getTime();
	   let dates = Math.abs((startTime - endTime)) / (1000 * 60 * 60 * 24);
	   return Math.ceil(dates);
	},
	// date为相加前的时间， days 为需要相加的天数
	addDate(date, days) {
	  var date = new Date(date);
	  date.setDate(date.getDate() + days);
	  var year = date.getFullYear();
	  var month = date.getMonth() + 1;
	  var day = date.getDate();
	  var mm = "'" + month + "'";
	  var dd = "'" + day + "'";
	  if(mm.length == 3) {
	    month = "0" + month;
	  }
	  if(dd.length == 3) {
	    day = "0" + day;
	  }
	  var time = year + "-" + month + "-" + day
	  return time+" 23:59:59";
	},
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.img-box {
  display: flex;
}

.img-item {
  width: 33.33333%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
